import React from 'react';

const Header = () => {
	return (
		<div className='header'>
			<h1>Global COVID-19 Tracker</h1>
		</div>
	);
};

export default Header;
